// share.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ShareService {

  async shareDocument(options: {
    title: string;
    text?: string;
    url?: string;
    file?: File;
  }): Promise<void> {

    const nav = navigator as any;

    try {
      // Compartir archivo real
      if (options.file) {
        const shareData = {
          title: options.title,
          text: options.text,
          files: [options.file],
        };

        if (nav.canShare && nav.canShare({ files: [options.file] })) {
          await nav.share(shareData);
          return;
        }
      }

      // Compartir enlace/texto
      if (nav.share) {
        await nav.share({
          title: options.title,
          text: options.text,
          url: options.url,
        });
        return;
      }

      // Fallback web: copiar enlace
      if (options.url) {
        await navigator.clipboard.writeText(options.url);
        alert('Enlace copiado al portapapeles');
        return;
      }

      alert('Tu navegador no soporta compartir este contenido');

    } catch (error) {
      console.error('Error al compartir:', error);
    }
  }
}